
document.addEventListener("DOMContentLoaded", function () {
    function checkSelectedOption() {
        const selectedOption = document.querySelector('input[name="purchase_option"]:checked');

        if (selectedOption) {
            if (selectedOption.value === "subscription") {
                document.querySelectorAll(".product-option__price_custom .product_price_onetime")
                    .forEach(el => el.style.display = "none");
                document.querySelectorAll(".product-option__price_custom .product_price_subscription")
                    .forEach(el => el.style.display = "block");
            } else if (selectedOption.value === "simple-product") {
                document.querySelectorAll(".product-option__price_custom .product_price_subscription")
                    .forEach(el => el.style.display = "none");
                document.querySelectorAll(".product-option__price_custom .product_price_onetime")
                    .forEach(el => el.style.display = "flex");
            }
        }
    }
    window.checkSelectedOption = checkSelectedOption;
    function initQty() {
        document.body.classList.add('hypothesis-15-pdp-flavour', 'hypothesis-15-pdp-flavour-var2');

        $(".open-quantity-bar").each(function () {
            $(this).show();
            $(this).on("click", function () {
                $(this).hide();
                const $next = $(this).next();
                $next.show().css("display", "flex");
                $next.find(".qty-plus").trigger("click");
            });
        });

        $(document).on('click', '.product-single-variant .quantity .qty-minus', function () {
            let button_element = $(this);
            setTimeout(function () {
                let qty_current = parseInt(button_element.parents('.quantity').find('.js-quantity-input').val());
                if (qty_current == 0) {
                    button_element.parents('.quantity').hide();
                    button_element.parents('.quantity').prev().show();
                } else {
                    button_element.parents('.quantity').prev().hide();
                }
            }, 50);
        });

        checkSelectedOption();

        document.querySelectorAll('input[name="purchase_option"]').forEach(function (input) {
            input.addEventListener('change', checkSelectedOption);
        });
    }

    initQty();
});
